export default function FileHeading({ heading }: { heading: string }) {
  return <h1 className="text-md mt-2 mb-2 leading-8 font-bold">{heading}</h1>;
}
